export default "__VITE_PUBLIC_ASSET__65701f01__"